<template>
  <gg-modal :is-active="opened" @close="close">
    <template v-slot:toolbar>
      Access Invitation
    </template>
    <template v-slot:body>
      <v-form @submit.prevent>
        <gg-text-field outlined
                      label="Email"
                      v-model="email"
                      name="Email"
                      :error-messages="errors.collect('Email')"
                      v-validate="'required|email'"></gg-text-field>
        <gg-select dense
                  outlined
                   label="Select a service"
                  :items="serviceList"
                  name="Service"
                  :item-text="serviceText"
                  item-value="id"
                  v-model="service"
                  v-validate="'required'"
                  :error-messages="errors.collect('Service')">
          <template v-slot:item="{ item }">
            {{ item.name }}<template v-if="item.domain">: {{ item.domain }}</template>
          </template>
        </gg-select>
      </v-form>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="invite">
        Invite
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import amapi from 'Api/amapi'
import { mapActions, mapGetters } from 'vuex'
import { SERVICE_TYPES } from '@/consts/service'

// The services that can be shared (core's invite_new accepts the same ones).
const SHAREABLE_TYPES = [
  SERVICE_TYPES.CPANEL,
  SERVICE_TYPES.RESELLER,
  SERVICE_TYPES.VPS,
  SERVICE_TYPES.DEDICATED,
  SERVICE_TYPES.KVM,
]

export default {
  name: 'AccessInvitationModal',
  props: {
    opened: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      email: '',
      service: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['services']),
    serviceList () {
      return this.services.filter(service => {
        return !service.sharedaccount && SHAREABLE_TYPES.includes(service.type)
      })
    },
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess', 'getAccountList', 'getAccessList']),
    // A server can have no domain; fall back to its plan name.
    serviceText (service) {
      return service.domain || service.name
    },
    async invite () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        const response = await amapi.makecall('invite_new', { email: this.email, service: this.service })
        await this.getAccessList()

        this.reportSuccess(response.resultmsg)
        this.email = ''
        this.service = ''
        this.close()
      } catch (e) {
        this.reportError(e)
        this.loading = false
      }
      this.loading = false
    },
    close () {
      this.$emit('close')
      this.email = ''
      this.alias = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
  }
}
</script>
